import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

const OPTIONS = [
  {
    icon: <AccountBalanceOutlinedIcon sx={{ fontSize: 34 }} />,
    title: 'Connect your bank',
    description: 'Link your accounts securely via Akahu and transactions sync automatically.',
    cta: 'Connect a bank',
    path: '/settings',
  },
  {
    icon: <CloudUploadIcon sx={{ fontSize: 34 }} />,
    title: 'Import a CSV',
    description: 'Export transactions from your bank and bring the history in yourself.',
    cta: 'Import transactions',
    path: '/import',
  },
  {
    icon: <ListAltIcon sx={{ fontSize: 34 }} />,
    title: 'Start manually',
    description: 'Add transactions and categories by hand and build up as you go.',
    cta: 'Add transactions',
    path: '/transactions',
  },
];

// First-run page shown right after registration: three ways to get data into
// the app, so a new user never lands on an empty dashboard wondering what next.
const Onboarding = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', px: { xs: 1, sm: 2 }, py: { xs: 3, md: 6 } }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Welcome to Budget Clues 👋
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Your money leaves clues. Let's find some! How would you like to get your first transactions in?
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2.5 }}>
        {OPTIONS.map((option) => (
          <Paper
            key={option.path}
            variant="outlined"
            sx={{
              p: 3,
              borderRadius: 3,
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
              transition: 'box-shadow 0.2s, transform 0.2s',
              '&:hover': { boxShadow: '0 6px 20px rgba(244,20,104,0.12)', transform: 'translateY(-2px)' },
            }}
          >
            <Box sx={{ color: 'primary.main' }}>{option.icon}</Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>{option.title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
              {option.description}
            </Typography>
            <Button
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={() => navigate(option.path)}
              sx={{ alignSelf: 'flex-start', textTransform: 'none', fontWeight: 600, borderRadius: 2 }}
            >
              {option.cta}
            </Button>
          </Paper>
        ))}
      </Box>

      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Button onClick={() => navigate('/dashboard')} sx={{ textTransform: 'none', color: 'text.secondary' }}>
          Skip for now and take me to my dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default Onboarding;
